import type { FoodOutDetailsListModel, KitchenTaskReleaseResultModel } from '@/model/kitchen';
import { changeKitchenStatus } from '@/service/kitchen';
import { distributeStove } from '@/service/order';

// 退回任务时保留服务员暂停、加急和优先级，交接后由接班厨师重新开始制作。
export const releaseStoveTasks = async (
  tasks: FoodOutDetailsListModel[],
  shouldContinue: () => boolean = () => true,
): Promise<KitchenTaskReleaseResultModel> => {
  const result: KitchenTaskReleaseResultModel = { releasedCount: 0, failedCount: 0 };
  for (const task of tasks) {
    if (!shouldContinue()) break;
    if (!task.stoveId || task.kitchenStatus === 10 || [8, 9, 999].includes(task.status)) continue;
    try {
      if (task.kitchenStatus !== 0) {
        const resetResponse = await changeKitchenStatus({
          orderOutId: task.orderOutId,
          kitchenStatus: 0,
        });
        if (resetResponse.code !== 200) throw new Error(resetResponse.msg || '退回待制作失败');
      }
      const response = await distributeStove({ orderOutId: task.orderOutId, stoveId: null });
      if (response.code !== 200) throw new Error(response.msg || '移出厨师队列失败');
      result.releasedCount++;
    } catch (error) {
      console.error(`转交菜品 ${task.orderOutId} 失败`, error);
      result.failedCount++;
    }
  }
  return result;
};
